let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9R3Ww")).then(() => parcelRequire('5mbGr'));